// Copyright: IQGeo Limited 2010-2019
import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import myw from 'myWorld-base';
import userGroupsHtml from 'text!html/userGroups.html';
import 'myWorld/uiComponents/dialog';

const editorHtml = $(userGroupsHtml)
    .filter('#user-group-editor-template')
    .html();
const newMemberRowHtml = $(userGroupsHtml)
    .filter('#new-member-row-template')
    .html();
const actionsHtml = $(userGroupsHtml)
    .filter('#group-editor-actions-template')
    .html();

myw.UserGroupForm = myw.Form.extend({
    messageGroup: 'UserGroupEditor',
    className: 'user-group-editor ui-form',

    events: {
        'click .add-member-btn': 'addMemberToGroup'
    },
    actionsTemplate: _.template(actionsHtml),
    editorTemplate: _.template(editorHtml),

    initialize(options) {
        this.isNew = options.isNew;

        const schema = {
            messageGroup: 'UserGroupEditor',
            onChange: options.onChange
        };

        if (this.isNew) {
            schema.rows = [
                {
                    components: [
                        new myw.Input({
                            name: 'name',
                            cssClass: 'full-width',
                            placeholder: this.msg('name'),
                            value: options.model.name || ''
                        })
                    ]
                },
                {
                    components: [
                        new myw.Label({
                            label: '<strong>{:description}:</strong>'
                        }),
                        new myw.Textarea({
                            name: 'description',
                            cssClass: 'full-width',
                            value: options.model.description || ''
                        })
                    ]
                }
            ];
        } else {
            schema.rows = [
                {
                    components: [
                        new myw.Label({
                            label: `<strong>{:owner}:</strong> ${options.model.owner}`
                        })
                    ]
                },
                {
                    components: [
                        new myw.Label({
                            label: '<strong>{:description}:</strong>'
                        }),
                        new myw.Textarea({
                            name: 'description',
                            cssClass: 'full-width',
                            value: options.model.description || ''
                        })
                    ]
                }
            ];
        }

        this.memberViews = [];

        myw.Form.prototype.initialize.call(this, _.extend(schema, options));
        this.options = _.extend(this.options, options);
    },

    render() {
        myw.Form.prototype.render.call(this);
        this.$el.append(this.editorTemplate({ userHasEditPerm: true }));
        if (!this.isNew) {
            _.each(_.keys(this.options.model.members), member => {
                const memberView = new GroupMember({
                    owner: this,
                    isManager: this.options.model.members[member],
                    name: member,
                    placeholder: this.msg('member_username')
                });
                this.memberViews.push(memberView);
                this.$('.members-list').append(memberView.$el);
            });
        }
    },

    getValues() {
        const groupData = myw.Form.prototype.getValues.call(this);
        const members = this.getMembersList();

        return _.extend(groupData, {
            members: members,
            owner:
                typeof this.options === 'undefined'
                    ? myw.currentUser.username
                    : this.options.model.owner
        });
    },

    getMembersList() {
        const members = {};

        _.each(this.memberViews, memberView => {
            const memberVal = memberView.getValue();
            if (memberVal) _.extend(members, memberVal);
        });
        return members;
    },

    addMemberToGroup() {
        const newRow = new GroupMember({
            owner: this,
            isManager: false,
            name: null,
            placeholder: this.msg('member_username')
        });
        this.memberViews.push(newRow);
        this.$('.members-list').append(newRow.$el);
    },

    displayMessage(message, type) {
        new myw.DisplayMessage({ el: this.$('.message-container'), type: type, message: message });
    }
});

const groupMemberHtml = $(userGroupsHtml)
    .filter('#group-member-template')
    .html();
const GroupMember = Backbone.View.extend({
    tagName: 'li',
    messageGroup: 'UserGroupEditor',
    events: {
        'click .remove-btn': 'removeFromGroup',
        'click .manager-btn': 'toggleManager'
    },
    template: _.template(groupMemberHtml),
    initialize(options) {
        this.options = options;
        this.msg = options.owner.msg;
        this.isManager = this.options.isManager;
        this.render();
    },

    render() {
        this.$el.html(this.template(this.options));
    },

    toggleManager() {
        this.isManager = !this.isManager;
        this.$('.manager-btn').toggleClass('active', this.isManager);
    },

    removeFromGroup() {
        this.$el.remove();
        this.options.owner.memberViews = _.without(this.options.owner.memberViews, this);
    },

    getValue() {
        const memberName = $.trim(this.$('input').val());

        if (memberName) {
            const memberObj = {};
            memberObj[memberName] = this.isManager;
            return memberObj;
        } else {
            return null;
        }
    }
});

export default myw.UserGroupForm;
